import _ from 'underscore';
import ko from 'knockout';
import { getMapper } from '../mapper/index';
import { Formatter } from '../formatter/index';
import { isRaiseOpportunity } from '../config/index';

function sumBy(array, iteratee = _.identity) {
  return _.reduce(array, (memo, item) => memo + _.iteratee(iteratee)(item), 0);
}

function getCostPerConversion(cost, conversion) {
  return conversion === 0 ? 0 : cost / conversion;
}

export default class ViewModel {
  constructor({
    type,
    i18n,
    details,
    campaignBIData = { cost: 0, conversion: 0 },
  }) {
    this.type = type;
    this.i18n = i18n;
    this.formatter = new Formatter(i18n);

    this.all = ko.observableArray(getMapper(this.type, details, this.i18n));

    this.raiseBidAdjustments = ko.pureComputed(() =>
      _.filter(this.all(), opportunity => isRaiseOpportunity(opportunity, this.type)));

    this.lowerBidAdjustments = ko.pureComputed(() =>
      _.filter(this.all(), opportunity => !isRaiseOpportunity(opportunity, this.type)));

    this.selectedRaiseBidAdjustments = ko.observableArray(this.raiseBidAdjustments());
    this.selectedLowerBidAdjustments = ko.observableArray(this.lowerBidAdjustments());

    this.selected = ko.pureComputed(() =>
      this.selectedRaiseBidAdjustments().concat(this.selectedLowerBidAdjustments()));

    this.old = {};
    this.delta = {};
    this.new = {};

    this.campaignBIData = ko.observable(campaignBIData);

    _.each(['conversion', 'cost'], (biData) => {
      this.old[biData] = ko.pureComputed(() => this.campaignBIData()[biData]);
      this.delta[biData] = ko.pureComputed(() => sumBy(this.selected(), `${biData}Delta`));
      this.new[biData] = ko.pureComputed(() => this.old[biData]() + this.delta[biData]());
    });

    _.each(['old', 'new'], (scope) => {
      this[scope].costPerConversion = ko.pureComputed(() =>
        getCostPerConversion(this[scope].cost(), this[scope].conversion()));
    });

    this.delta.costPerConversion = ko.pureComputed(() =>
      this.new.costPerConversion() - this.old.costPerConversion());

    this.formatedRange = {};
    this.formatedDelta = {};
    this.biSymbol = {};
    _.each(['conversion', 'costPerConversion', 'cost'], (biData) => {
      const dataType = biData;

      this.formatedRange[biData] = ko.pureComputed(() =>
        this.i18n.getString('BidAdjustmentOpt_Range', {
          from: this.formatter.formatValueWithType(this.old[biData](), dataType),
          to: this.formatter.formatValueWithType(this.new[biData](), dataType),
        }));

      this.formatedDelta[biData] = ko.pureComputed(() => {
        const delta = this.delta[biData]();

        if (delta) {
          return delta === 0 ? '--' : this.formatter.formatValueWithType(delta, `${dataType}Delta`);
        }
        return '--';
      });

      this.biSymbol[biData] = ko.pureComputed(() => {
        const delta = this.delta[biData]();

        if (delta) {
          return delta > 0 ? 'opportunity-detail-asc-icon' : 'opportunity-detail-des-icon';
        }
        return '';
      });
    });
  }

  setRaiseOrLowerDetails(details, campaignBIData) {
    if (campaignBIData) {
      this.campaignBIData(campaignBIData);
    }
    this.all(getMapper(this.type, details, this.i18n));

    this.selectedRaiseBidAdjustments(this.raiseBidAdjustments());
    this.selectedLowerBidAdjustments(this.lowerBidAdjustments());
  }
}
